let vibe_cake_masters_lesson_video = function( $ ) {

	let $video,
		video_type,
		vimeo_player,
		youtube_player,
		youtube_script_tag_src = 'https://www.youtube.com/iframe_api',
		youtube_api_ready      = false,
		youtube_added_script   = false,
		vimeo_api_ready        = false,
		vimeo_script_tag_src   = 'https://player.vimeo.com/api/player.js';

	window.onYouTubeIframeAPIReady = function() {
		youtube_api_ready = true;
	};

	let _init = function() {
		$video = $( '#masters-single-lesson-content .video-section .masters-video' );

		if ( $video.length > 0 ) {
			video_type = $video.hasClass( 'youtube-video' ) ? 'youtube' : $video.hasClass( 'vimeo-video' ) ? 'vimeo' : false;

			if ( video_type === 'youtube' ) {
				_setup_youtube_video();
			} else if ( video_type === 'vimeo' ) {
				_setup_vimeo_video();
			}
		}
	};

	let _setup_youtube_video = function() {
		$video.loading();

		if ( youtube_api_ready ) {
			$video.loaded();

			youtube_player = new YT.Player( $video.find( 'iframe' ).get( 0 ), {
				height : '390',
				width : '640',
				videoId : 'lesson-video',
				events : {
					'onStateChange' : ( event ) => {
						if ( event.data === 0 ) {
							complete_video();
						}
					}
				}
			} );
		} else {
			_load_api_script( 'youtube' );

			setTimeout( () => {
				_setup_youtube_video();
			}, 20 );
		}
	};

	let _load_api_script = function( type = 'youtube' ) {
		let should_insert    = false,
			tag              = document.createElement( 'script' ),
			first_script_tag = document.getElementsByTagName( 'script' )[0];

		if ( type === 'youtube' && ! youtube_added_script && ! _script_tag_exists( 'youtube' ) ) {
			tag.id  = 'youtube-iframe-api';
			tag.src = youtube_script_tag_src;

			should_insert = true;
		} else if ( type === 'vimeo' ) {
			tag.id = 'vimeo-iframe-api';
			tag.src = vimeo_script_tag_src;

			should_insert = true;
		}

		if ( should_insert ) {
			first_script_tag.parentNode.insertBefore( tag, first_script_tag );

			if ( type === 'vimeo' ) {

				setTimeout( () => {
					vimeo_api_ready = true;
				}, 100 );
			}
		}
	};

	let _script_tag_exists = function( type = 'youtube' ) {
		let scripts = document.getElementsByTagName( 'script' ),
			url     = type === 'youtube' ? youtube_script_tag_src : type === 'vimeo' ? vimeo_script_tag_src : false;

		if ( url ) {
			for ( let i = scripts.length; i--; ) {
				if ( scripts[i].src === url ) {

					if ( type === 'vimeo' ) {
						setTimeout( () => {
							vimeo_api_ready = true;
						}, 50 );
					}

					return true;
				}
			}
		}
		return false;
	};

	let _setup_vimeo_video = function() {
		$video.loading();

		if ( vimeo_api_ready ) {
			$video.loaded();

			vimeo_player = new Vimeo.Player( $video.find( 'iframe' ).get( 0 ) );
			vimeo_player.on( 'ended', ( e ) => {
				complete_video();
			} );

		} else {
			_load_api_script( 'vimeo' );

			setTimeout( () => {
				_setup_vimeo_video();
			}, 100 );
		}
	};

	let complete_video = function( lesson_id = false, video_id = false ) {
		let $video_wrapper = $( '#masters-single-lesson-content .video-section' );

		if ( ! lesson_id ) {
			lesson_id = $video_wrapper.data( 'lesson-id' );
		}

		if ( ! video_id ) {
			video_id = $video_wrapper.data( 'video-id' );
		}

		let data = {
			nonce: VibeCakeMastersScriptData.vibe_cake_masters_complete_video_complete_nonce,
			action: 'vibe_cake_masters_complete_video_complete',
			lesson_id: lesson_id,
			video_id: video_id,
		};

		$.post( VibeCakeMastersScriptData.ajaxurl, data, ( response ) => {
			// No need to do anything here
			$( 'html body' ).trigger( 'masters-lesson_video_marked_complete', response );
		} );
	};

	$( document ).ready( _init );

	return {
		complete_video : complete_video,
	}

} ( jQuery );

module.exports = vibe_cake_masters_lesson_video;